import React, { useEffect } from 'react'
import { useReduxDispatch, useReduxSelector } from '../redux/hooks';
import { ChatApi } from '../redux/api/ChatApi';
import { ChatIsUnRead } from '../util/ChatUtils';
import { NotificationLog } from '../types/NotificationLog';
import { SetNotifications } from '../redux/reducers/ChatSlice';

export default function NewMessageSound() {
    const dispatch = useReduxDispatch();
    const { data: profile } = ChatApi.useGetProfileQuery();
    const { data: chats } = ChatApi.useGetChatsQuery();
    const { config, notifications } = useReduxSelector(s => s.chat);
    const unreadChats = chats?.filter(c => ChatIsUnRead(profile?.Uid, c));
    useEffect(() => {
        //Play Sound when chat message is received
        const notNotified = unreadChats?.filter(c => !notifications?.find(log => log.conversationId == c.ConversationId && c.Last_Message_Contact_Id != profile.Id && log.lastMessage.toISOString() == new Date(c.Last_Message_Date).toISOString()));
        const dateFind = unreadChats?.filter(c => notifications?.find(log => log.lastMessage.toISOString() == new Date(c.Last_Message_Date).toISOString()));
        console.log('Playing audio...', 'notNotified=', notNotified?.length, 'Play_Sound=', config?.Play_Sound);
        //console.log('notifications.lastMessage.toISOString()', notifications.map(m => m.lastMessage.toISOString()), unreadChats.map(m => new Date(m.Last_Message_Date).toISOString()), 'find=', dateFind);
        if (notNotified?.length > 0 && config?.Play_Sound) {

            //this could fail:play() failed because the user didn't interact with the document first.
            try {
                const audio = new Audio('./sounds/new-message.wav');
                audio.volume = config.Sound_Volume / 10;
                audio.play().then(e => console.log('Sound played')).catch(e => console.error('Sound error:' + e));
            } catch (e) {
                console.error('Sound error:' + e);
            }
            let newNotificationLog = [...notifications]
            newNotificationLog = newNotificationLog.filter(n => !notNotified.find(nn => nn.ConversationId == n.conversationId)) //Remove existing
            newNotificationLog = newNotificationLog.concat(notNotified.map(c => { return { conversationId: c.ConversationId, lastMessage: new Date(c.Last_Message_Date) } as NotificationLog }));
            //remove old logs
            //newNotificationLog = newNotificationLog.filter(n=> notNotified.find(nn=> nn.ConversationId == n.conversationId) !== null);
            //newNotificationLog = newNotificationLog.push();
            console.warn('SetNotifications', newNotificationLog?.length)

            //Set the chats that have been 'dinged'
            dispatch(SetNotifications(newNotificationLog));
        }
    }, [unreadChats?.length]);

    return (
        <>
            {/* NewMessageSound {unreadChats?.length} */}
        </>
    )
}
